import { Select } from '../../../design-system';
import { describePerson } from '../../../lib/clientPeople';

// "Fill from someone already on this client."
//
// The same director gets typed onto the board, the signatory list, the officer
// list and the cap table — name, PAN and DIN retyped each time. This offers the
// people already on the record so the identity fields come from one place. The
// second time somebody types a 10-character PAN they get it wrong, and then the
// same human exists twice under two PANs with nothing able to tell.
//
// ⚠️ IT FILLS BLANKS, IT DOES NOT OVERWRITE. Picking somebody must never
// silently replace a value already typed into the row — that turns a
// convenience into a way to lose work. The caller decides which fields a given
// list actually has (`fields`), because a contact has an email and a board seat
// does not.
export default function PersonPicker({
  people,
  onPick,
  fields = ['name', 'pan', 'din'],
  label = 'Fill from someone on this client',
  exclude = [],
}) {
  // Nothing to offer on an empty client — the first person on a fresh record is
  // always typed, and an empty dropdown is just noise.
  const options = people.filter((p) => !exclude.includes(p.key));
  if (options.length === 0) return null;

  const handle = (e) => {
    const person = options.find((p) => p.key === e.target.value);
    // Reset immediately: this is an action, not a value. Leaving the name
    // selected would read as "this row IS that person" once the fields are
    // edited away from them.
    e.target.value = '';
    if (!person) return;

    const patch = {};
    for (const f of fields) if (person[f]) patch[f] = person[f];
    onPick(patch, person);
  };

  return (
    <Select label={label} value="" onChange={handle} className="person-picker">
      <option value="">— Type a new person —</option>
      {options.map((p) => (
        <option key={p.key} value={p.key}>{describePerson(p)}</option>
      ))}
    </Select>
  );
}
